const RESERVED_SCENARIO_TYPES = new Set(['default', 'bull', 'bear', 'other']);

export function slugifyScenarioName(name) {
  let slug = String(name || '')
    .trim()
    .toLowerCase()
    .replace(/[^\w.-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');

  if (!slug) {
    return null;
  }

  if (RESERVED_SCENARIO_TYPES.has(slug)) {
    slug = `custom-${slug}`;
  }

  return slug;
}

export function titleCaseScenarioSlug(slug) {
  return String(slug || '')
    .split('-')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export const SCENARIO_ADD_OPTION = '__add__';

export const RESERVED_SCENARIO_TYPE_SET = RESERVED_SCENARIO_TYPES;
